(function($){
    $('.platek-accessbility a').on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('fplus')){
            $('.pojo-a11y-btn-resize-plus').click();
        }
        else if($(this).hasClass('fminus')){
            $('.pojo-a11y-btn-resize-minus').click();
        }
        else if($(this).hasClass('contrast')){
            $('.pojo-a11y-btn-high-contrast').click();
        }
    })
})(jQuery)